'use client';

import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { usePathname } from 'next/navigation';

import { languageAlternatesAtom } from '@packages/modules/src/Header/MetaNavigation/shared/useLocaleSwitch.atom';
import { usePRankOptinTracking } from '@packages/search/src/hooks/usePRankTracking';

export const CategoryPageEffects = ({
  alternateLinks,
}: {
  alternateLinks?: Record<string, string>;
}) => {
  const pathname = usePathname();
  const setLanguageAlternates = useSetAtom(languageAlternatesAtom);

  useEffect(() => {
    setLanguageAlternates({
      currentPathname: pathname ?? 'unknown',
      alternateLinks,
    });
  }, [alternateLinks, pathname, setLanguageAlternates]);

  // pRank A/B test: Send OPTIN: 1 once per category page entry
  usePRankOptinTracking();

  return null;
};
